<template>
  <b-modal
    size="xxl"
    v-model="showForm"
    :title="formTitle + ' bệnh nhân'"
    @ok="save"
    no-close-on-backdrop
    no-enforce-focus
  >
    <div class="row">
      <div class="col-md">
        <form-input
          label="Tên"
          :model="formModel"
          attribute="name"
          :errors="formErrors"
          placeholder="Tên bệnh nhân (bắt buộc nhập)"
        ></form-input>
        <form-input
          label="Số điện thoại"
          :model="formModel"
          attribute="phone"
          :errors="formErrors"
          placeholder="Số điện thoại (bắt buộc nhập)"
        ></form-input>
        <form-input
          label="Năm sinh"
          :model="formModel"
          attribute="dob"
          :errors="formErrors"
          placeholder="Năm sinh"
        ></form-input>
        <form-input
            label="Tuổi"
            :model="formModel"
            attribute="age"
            :errors="formErrors"
            placeholder="Tuổi"
        ></form-input>
        <form-select
          label="Giới tính"
          :model="formModel"
          attribute="gender"
          :errors="formErrors"
          :options="[
            {value: 'unknown', text: 'Chọn giới tính'},
            {value: 'male', text: 'Nam'},
            {value: 'female', text: 'Nữ'},
          ]"
        ></form-select>
        <form-group-address
          :model="formModel"
          province-attribute="provinceCode"
          district-attribute="districtCode"
          ward-attribute="wardCode"
          :errors="formErrors"
        ></form-group-address>
        <form-input
          label="Địa chỉ"
          :model="formModel"
          attribute="address"
          :errors="formErrors"
          placeholder="Số nhà, tên đưởng, tổ dân phố, xóm,... (Tối đa 100 ký tự)"
        ></form-input>
        <user-group-select-form label="Chọn nhóm" :model="formModel" attribute="group" :errors="formErrors"
        ></user-group-select-form>
        <user-select
          label="Chọn bác sĩ"
          :model="formModel"
          attribute="doctorUser"
          :group-filter="formModel.group"
          :errors="formErrors"
          :rolesFilter="['bac-sy', 'bac-sy-pho-nhom']"
        ></user-select>
        <user-select
          label="Chọn tình nguyện viên"
          :model="formModel"
          attribute="followUser"
          :errors="formErrors"
          :group-filter="formModel.group"
          :roles-filter="['nvyt']"
        ></user-select>
      </div>
      <div class="col-md">
        <form-input
          label="Mã xét nghiệm"
          :model="formModel"
          attribute="testCode"
          :errors="formErrors"
          placeholder="Mã xét nghiệm (bắt buộc nhập)"
        ></form-input>
        <form-input
          label="Lý do xét nghiệm"
          :model="formModel"
          attribute="testReason"
          placeholder="Lý do xét nghiệm"
          :errors="formErrors"
        ></form-input>
        <form-input
          label="Ngày xét nghiệm"
          :model="formModel"
          attribute="testDate"
          :errors="formErrors"
          placeholder="Ngày xét nghiệm"
        ></form-input>
        <form-input
            label="Ngày ra khỏi BV / khu cách ly"
            :model="formModel"
            attribute="getOutOfHospitalDate"
            :errors="formErrors"
            placeholder="Ngày ra khỏi BV / khu cách ly"
        ></form-input>
        <form-input
          label="CT value"
          :model="formModel"
          attribute="ctValue"
          :errors="formErrors"
          placeholder="CT value"
        ></form-input>
        <form-input
          label="Mức CT"
          :model="formModel"
          attribute="ctLevel"
          :errors="formErrors"
          placeholder="Mức CT"
        ></form-input>
        <form-input
          label="Họ tên bác sỹ ở địa phương"
          :model="formModel"
          attribute="fieldDoctor"
          :errors="formErrors"
          placeholder="Họ tên bác sỹ ở địa phương"
        ></form-input>
        <form-input
          label="Điện thoại bác sỹ ở địa phương"
          :model="formModel"
          attribute="fieldDoctorPhone"
          :errors="formErrors"
          placeholder="Điện thoại bác sỹ ở địa phương"
        ></form-input>
        <form-textarea
          label="Ghi chú"
          :model="formModel"
          attribute="note"
          :errors="formErrors"
          placeholder="Ghi chú"
        ></form-textarea>
      </div>
    </div>
    <template v-slot:modal-footer>
      <b-button variant="secondary" class="float-right" @click="showForm = false">{{ $t('cancel') }}</b-button>
      <b-button :disabled="saveLoading" variant="primary" class="float-right" @click="save">
        <b-spinner v-if="saveLoading" small></b-spinner>
        {{ $t('save') }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import crud from '@/mixins/CRUD';
import FormGroupAddress from '../../components/address/FormGroupAddress.vue';
import UserSelect from '@/components/UserSelect';
import UserGroupSelectForm from "@/components/UserGroupSelectForm";
import moment from 'moment';

export default {
  components: {UserGroupSelectForm, FormGroupAddress, UserSelect},
  mixins: [crud],
  data() {
    return {
      service: '/benh-nhan',
      reloadBus: 'reloadBenhNhanList',
      defaultFormModel: {
        testCode: null,
        name: null,
        testReason: null,
        testDate: null,
        ctValue: 0,
        phone: null,
        dob: null,
        age: null,
        gender: 'unknown',
        address: null,
        wardCode: null,
        districtCode: null,
        provinceCode: null,
        doctorUser: null,
        followUser: null,
        fieldDoctor: null,
        fieldDoctorPhone: null,
        note: null,
      },
    };
  },
  methods: {
    genTestCode() {
      if (this.$store.state.user.group && ['610e362ce7aef55208d80670', '610e25b9d8ba7b532cc750a8'].includes(this.$store.state.user.group)) {
        return `G23-${moment(Date.now()).format('YYMMDDHHmmss')}`
      }
      return null
    },
    create() {
      this.formModel = {};
      this.formModel = Object.assign({}, this.defaultFormModel);
      if (this.$store.state.user.group && ['610e362ce7aef55208d80670', '610e25b9d8ba7b532cc750a8'].includes(this.$store.state.user.group)) {
        this.formModel.testCode = `G23-${moment(Date.now()).format('YYMMDDHHmmss')}`;
        this.formModel.group = this.$store.state.user.group
      }
      this.formTitle = this.$t('create');
      this.formErrors = [];
      this.showForm = true;
    }
  }
};
</script>
